module.exports = __webpack_public_path__ + "img/arrecredi_qrcode_1.e7559614.jpeg";